import { render, staticRenderFns } from "./CampaignEvent.vue?vue&type=template&id=132aaae6&scoped=true"
import script from "./CampaignEvent.vue?vue&type=script&lang=js"
export * from "./CampaignEvent.vue?vue&type=script&lang=js"
import style0 from "./CampaignEvent.vue?vue&type=style&index=0&id=132aaae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132aaae6",
  null
  
)

export default component.exports